import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMildIrritationSelectedEmojiSecondary from './svgs/MildIrritationSelectedEmojiSecondary.js';
import SvgMildIrritationSelectedEmoji from './svgs/MildIrritationSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var mildIrritationSelectedEmoji = (props => useIcon(SvgMildIrritationSelectedEmoji, SvgMildIrritationSelectedEmojiSecondary, props));

export { mildIrritationSelectedEmoji as default };
